import { Component, HostListener } from '@angular/core';
import { LayoutService } from '../../shared/services/layout.service';
import { PlantMapService } from '../services/plant-map.service';
import { ActivatedRoute } from '@angular/router';
import { STATIC_VALUE } from '../../shared/configuration/static.value';

// Page created by Kowsalya

@Component({
	selector: 'confirmation-cancel',
	templateUrl: 'confirmation-cancel.component.html'
})
export class cancelconfirmation {

    vStatustest: boolean;
    vPlantRequestID: string;
    vStatus: string;

    constructor(
        private _layoutService: LayoutService,
        private _plantmapService: PlantMapService,
        private _activatedRoute: ActivatedRoute 
	){}
    
    ngOnInit(){
        this._layoutService.setCurrentPage('confirmation-cancel');
        this.vStatustest = true;

        this._layoutService.setCurrentPage('plantmap-confirmation');
        this.vPlantRequestID = this._plantmapService.getRequestId();
        console.log("Line 37",this._activatedRoute.snapshot.queryParams);
        this._plantmapService.getPaymentAvailability().then(
            (resolve) => {
                console.log("Line 34");
                if(resolve['data'].payment) { // contractor
                    console.log("Line 36");
                    let transactionParam = this._activatedRoute.snapshot.queryParams;
                    console.log(this._activatedRoute.snapshot.queryParams);
                    if(transactionParam["resultIndicator"] !== undefined && transactionParam["resultIndicator"] === this._plantmapService.vPlantMapData.success_indicator){
                        console.log("Line 40");
                        this.loadTransaction(transactionParam);
                    } else {
                        console.log("Line 43");
                        this.loadTransaction(transactionParam);
                        this.vStatustest = true;//Kowsalya
                    }

                } else { // government
                    if(this._plantmapService.vAreaOfInterestData.restricted_area == 1){
                        console.log("Line 49");
                        this.vStatus = STATIC_VALUE.ALL_PLANT_STATUS.PENDING_MAP_COLLECTION;
                    } else {
                        console.log("Line 52");
                        this.vStatus = STATIC_VALUE.ALL_PLANT_STATUS.PAYMENT_RECEIVED;
                    }
                    this._plantmapService.gisPlantmapHit();
                    this._plantmapService.resetAllData();
                }
            },
            (reject) => {
                console.log("Line 60");
                this._plantmapService.resetAllData();
            }
        );
    }

    loadTransaction(transactionParam){
        this._plantmapService.loadTransaction(transactionParam["failure_reason"]).then(
            (resolve) => {
                this.vStatus = resolve['data'].status;
                if(this.vStatus == STATIC_VALUE.ALL_PLANT_STATUS.PAYMENT_RECEIVED) {
                    this._plantmapService.gisPlantmapHit();
                    this._plantmapService.resetAllData();
                } else {
                    this._plantmapService.resetAllData();
                    this.vStatustest = true;//Kowsalya
                }
            },
            (reject) => {
                console.log("Line 81");
                this._plantmapService.resetAllData();
            }
        );
    }

    isLoading(){
        return this._plantmapService.isLoading();
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/plantmap/components/confirmation-cancel.component.ts